//#region Imports

import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { BehaviorSubject, throwError, of, Subscription, Subject } from "rxjs";

import * as _ from 'lodash-es';
import moment from 'moment';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent, SelectItem, MenuItem } from 'primeng/api';

import { AppConsts } from "@shared/AppConsts";

import {
    OrderGuideServiceProxy,
    OrderGuideDto,
    OrderGuideForViewDto,
    BasketInputDto,
    IBasketInputDto,
    WebShopServiceProxy,
    CategoryDto,
    GetOrderGuideForEditOutput,
    OrderGuideSimpleDto,
    PagedResultDtoOfArticleDto,
    BasketArticleDto,
    ArticleDto,
    CategoryServiceProxy,
    PagedResultDtoOfOrderGuideSimpleDto,
    IBasketArticleDto
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { appModuleAnimation } from '@axilla/axilla-shared';

import { AppComponentBase } from '@shared/common/app-component-base';
import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { debounceTime, concatMap } from 'rxjs/operators';
//#endregion Imports

@Component({
    selector: 'app-delivery-selector',
    templateUrl: './delivery-selector.component.html',
    styleUrls: ['../../../dashboard/dashboard.component.less', './delivery-selector.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class DeliverySelectorComponent extends AppComponentBase implements OnInit, OnDestroy {

    @Input() items: any[];

    @Input() multiple?: boolean = false;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    @Output() selectDelivery: EventEmitter<any> = new EventEmitter();

    constructor(
        injector: Injector,
        private orderGuideServiceProxy: OrderGuideServiceProxy,
        private categoryServiceProxy: CategoryServiceProxy,
        private webShopServiceProxy: WebShopServiceProxy,
        private _notifyService: NotifyService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private route: ActivatedRoute,

        private _webshopService: WebshopService
    ) {
        super(injector);
    }


    ngOnInit(): void {


    }

    ngOnDestroy(): void {

    }


    get selectedDelivery(): any {
        return this._webshopService.selectedDelivery;
    }
    set selectedDelivery(item: any) {
        this._webshopService.selectedDelivery = item;

    }

    isSelected(item: any) {
        if (!this.selectedDelivery) {
            return false;
        }

        return this.selectedDelivery.code === item.code;
    }

    select($event: Event, item: any) {
        this.preventClick($event);

        if (item) {

            if (this.selectedDelivery && this.selectedDelivery.code === item.code) {
                this.selectedDelivery = null;
            } else {
                this.selectedDelivery = item;
            }

            this.selectDelivery.emit(this.selectedDelivery);
        }

    }

    preventClick($event: Event) {
        $event.stopPropagation();
    }

    getCurrency() {
        return this._webshopService.getCurrency();
    }

}

